/* global I18n */

import OrderItemsStore from './order_items_store'
import DynamicModal from 'modals/scripts/dynamic_modal'
import Track from 'tracking_events/scripts/track'
import WebsiteConfigs from 'website_configs/website_configs'
import Wizard from './wizard'
import { checkout as stripeCheckout } from './stripe'

const MODAL_SELECTOR = '#shopping_cart_modal'

class AddToCartButton {
  static async init () {
    const component = new AddToCartButton()
    component.bindEvents()
  }

  bindEvents () {
    $(document).on('click', '.js-add-to-cart-btn', (e) => this.onAddToCartClick(e))
  }

  onAddToCartClick (e) {
    const $target = $(e.currentTarget)
    const listingId = $target.data('listing-id')

    this.addListingToCart(listingId)

    if (Wizard.isSimpleBuyNow()) {
      this.checkout($target)
    } else {
      this.showWizard()
    }

    this.trackClickEvent(listingId)
  }

  addListingToCart (listingId) {
    if (WebsiteConfigs.webshopType === 'buy_now') {
      OrderItemsStore.clear()
    }
    OrderItemsStore.addItem({ listing_id: listingId })
  }

  checkout ($element) {
    const originalText = $element.text()
    $element.text(I18n.t('processing'))

    stripeCheckout().catch(() => {
      alert(I18n.t('checkout_error'))
      $element.text(originalText)
    })
  }

  showWizard () {
    const modal = new DynamicModal(MODAL_SELECTOR, { size: 'lg', header_title: WebsiteConfigs.shoppingCartHeaderTitle })
    modal.$body.empty()
    Wizard.render(modal.$body)
    modal.open()
  }

  trackClickEvent (listingId) {
    new Track().send('event', {
      event_category: 'add_to_cart_click',
      listing_ids: [listingId]
    })
  }
}

export default AddToCartButton
